// extracted by mini-css-extract-plugin
export default {"BodySmall":"body-small_BodySmall__W-XFL"};